import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { apiErrorMessage } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = anonymous
  const [error, setError] = useState(null);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("ol_token");
    if (!token) {
      setUser(null);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("ol_user", JSON.stringify(data));
    } catch {
      localStorage.removeItem("ol_token");
      localStorage.removeItem("ol_user");
      setUser(null);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    setError(null);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("ol_token", data.token);
      localStorage.setItem("ol_user", JSON.stringify(data.user));
      setUser(data.user);
      return data.user;
    } catch (e) {
      setError(apiErrorMessage(e, "Nie udało się zalogować"));
      throw e;
    }
  };

  const demoLogin = async (email) => {
    setError(null);
    try {
      const { data } = await api.post("/auth/demo-login", { email });
      localStorage.setItem("ol_token", data.token);
      localStorage.setItem("ol_user", JSON.stringify(data.user));
      setUser(data.user);
      return data.user;
    } catch (e) {
      setError(apiErrorMessage(e, "Nie udało się zalogować demo"));
      throw e;
    }
  };

  const logout = () => {
    localStorage.removeItem("ol_token");
    localStorage.removeItem("ol_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, error, login, demoLogin, logout, reload: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
